import { render } from "./DetailOriTable.vue?vue&type=template&id=47d9fde4&scoped=true"
import script from "./DetailOriTable.vue?vue&type=script&lang=js"
export * from "./DetailOriTable.vue?vue&type=script&lang=js"

import "./DetailOriTable.vue?vue&type=style&index=0&id=47d9fde4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47d9fde4"]])

export default __exports__